module.exports = {"220271001":"九站街道","220271013":"双吉街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220271.json
// module id = 622
// module chunks = 0